export const CONTACT_BATCH_GET_REQUEST = "CONTACT_BATCH_GET_REQUEST";
export const CONTACT_BATCH_GET_SUCCESS = "CONTACT_BATCH_GET_SUCCESS";
export const CONTACT_BATCH_GET_FAIL = "CONTACT_BATCH_GET_FAIL";
export const CONTACT_BATCH_GET_RESET = "CONTACT_BATCH_GET_RESET";